export const ADMIN = 'ADMIN';

export const roles = {
  ADMIN
};